import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/app/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/og_image_default.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/og_image_waterpages.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/AppDownloadModal/assets/arrow-black.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/AppDownloadModal/assets/PhonePreviewDesktop.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/AppDownloadModal/assets/PhonePreviewMobile.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/AppDownloadSection/assets/mobilePhonePreview.png");
;
import(/* webpackMode: "eager", webpackExports: ["AppRatingSection"] */ "/app/src/components/AppRatingSection/AppRatingSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime_desktop_brown_trout@2x.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime_desktop_jack_crevalle@2x.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime_desktop_largemouth_bass@2x.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime_desktop_northern_pike@2x.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime_desktop_snook@2x.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime_desktop_striped_bass@2x.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime_desktop_trahira@2x.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime_mobile_brown_trout@2x.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime_mobile_jack_crevalle@2x.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime_mobile_largemouth_bass@2x.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime_mobile_northern_pike@2x.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime_mobile_snook@2x.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime_mobile_striped_bass@2x.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime_mobile_trahira@2x.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime_tablet_brown_trout@2x.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime_tablet_jack_crevalle@2x.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime_tablet_largemouth_bass@2x.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime_tablet_northern_pike@2x.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime_tablet_snook@2x.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime_tablet_striped_bass@2x.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime_tablet_trahira@2x.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BitetimeDownloadSection/assets/bitetime-section-background.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/Clickables/Buttons/AppStoreButtons/AppStoreButtons.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Clickables/ExternalLink/ExternalLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FishingReportsGrid"] */ "/app/src/components/FishingReportsGrid/FishingReportsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FishingWaterMetadataPills"] */ "/app/src/components/FishingWaterMetadataPills/FishingWaterMetadataPills.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LatLng"] */ "/app/src/components/LatLng/LatLng.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Maps/assets/sprite_hybrid.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/Maps/assets/sprite_terrain.png");
;
import(/* webpackMode: "eager", webpackExports: ["HeroMapSection"] */ "/app/src/components/Maps/components/HeroMap/HeroMapSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageNavigation"] */ "/app/src/components/Navigation/PageNavigation/PageNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NearbyPlacesSection"] */ "/app/src/components/NearbyPlaces/NearbyPlacesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OtherAnglers"] */ "/app/src/components/OtherAnglers/OtherAnglers.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/QRCode/QRCode.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RegulationSection"] */ "/app/src/components/Regulations/RegulationSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/TrophySpeciesAppDownloadSection/assets/trophySpecies-desktop.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/TrophySpeciesAppDownloadSection/assets/trophySpecies-mobile.png");
;
import(/* webpackMode: "eager" */ "/app/src/helpers/errorHandling/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/app/src/views/FishingWater/components/FAQSection/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NearbyWatersSection"] */ "/app/src/views/FishingWater/components/NearbyWatersSection/NearbyWatersSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NoCatchesSection"] */ "/app/src/views/FishingWater/components/NoCatchesSection/NoCatchesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewsSection"] */ "/app/src/views/FishingWater/components/ReviewsSection/ReviewsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SuggestChangesSection"] */ "/app/src/views/FishingWater/components/SuggestChangesSection/SuggestChangesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopSpeciesSection"] */ "/app/src/views/FishingWater/components/TopSpeciesSection/TopSpeciesSection.tsx");
